import { isObject } from "@utils/type-checkers"
import type { Address } from "@stripe/stripe-js"


const parseAddress = (data?: Partial<Address>): Address => ({
    city: data?.city || '',
    country: data?.country || '',
    line1: data?.line1 || '',
    line2: data?.line2 || '',
    postal_code: data?.postal_code || '',
    state: data?.state || '',
    email: data?.email || ''
})

const parseTeraUserData = (data?: Partial<TeraUserData>): TeraUserData => ({
    userId: data?.userId || '',
    cardId: data?.cardId,
    activeGroup: data?.activeGroup,
    address: isObject(data?.address) ? parseAddress(data.address) : undefined,
    physicalCard: isObject(data?.physicalCard)
        ? {
            id: data?.physicalCard?.id || '',
            activeGroup: data?.physicalCard?.activeGroup || '',
            lastFour: data?.physicalCard?.lastFour || '',
        }
        : undefined,
    virtualCard: isObject(data?.virtualCard)
        ? {
            id: data?.virtualCard?.id || '',
            activeGroup: data?.virtualCard?.activeGroup || '',
            lastFour: data?.virtualCard?.lastFour || '',
        }
        : undefined
})

export { parseAddress, parseTeraUserData }
